import { useIntl } from '@capsicum/common';

import { useGoatImage } from '../../hooks/images/useGoatImage';
import { GenericDrawer, type GenericDrawerProps } from '../../ui/molecules/generic-drawer/GenericDrawer';

export const WebPushNotification = (props: GenericDrawerProps) => {
	const notificationsImage = useGoatImage('notifications');
	const { $t } = useIntl();

	return (
		<GenericDrawer
			buttonText={$t('pushNotifications.prompt.buttonText')}
			description={$t('pushNotifications.prompt.description')}
			image={notificationsImage}
			isButtonOnRow={false}
			title={$t('pushNotifications.prompt.title')}
			{...props}
		/>
	);
};
